/* repo/merchant*/
import { fetch as fetchApi } from "./api";
import { Audit } from "../store/audit/types";

const AUDITTRAIL = "auditTrail";

export async function fetch(id: string | null, params?: {}): Promise<Audit> {
  return fetchApi({
    nestedResourcePath: [AUDITTRAIL],
    id: id,
    params: params
  }).then(response => response.data);
}
